import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import AttendanceDetailReportDataTable from '../../AttendanceDetailReport/AttendanceDetailReportDataTable';

const AttendanceDetailProfileIndex = () => {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <>
      <Row className="mt-2">
        <Col>
          <h2 className="mb-2 mt-2">Detalle de Asistencia</h2>
        </Col>
      </Row>
      <AttendanceDetailReportDataTable rrhh={false} maxDays={31} />
    </>
  );
};

export default AttendanceDetailProfileIndex;
